import { render, staticRenderFns } from "./PaginatorTableComponent.vue?vue&type=template&id=660455b3&scoped=true&"
import script from "./PaginatorTableComponent.vue?vue&type=script&lang=js&"
export * from "./PaginatorTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660455b3",
  null
  
)

export default component.exports